<template>
  <div v-if="!isAuthorized" class="m-grid m-grid--hor m-grid--root m-page">
    <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 no-background"
        id="m_login">
      <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside white-background">
        <div class="m-stack m-stack--hor m-stack--desktop d-flex flex-grow-1 flex-column">
          <div class="m-stack__item m-stack__item--fluid d-flex flex-grow-1 align-items-center justify-content-center">
            <div class="m-login__wrapper d-flex no-padding flex-column mb-md-5">
              <div class="mx-auto mb-4 mt-4">
                <div class="max-width-320" v-if="logoUrl">
                  <img class="logo" alt="" :src="logoUrl">
                </div>
                <div v-else>
                  <h4 class="font-ls" v-encode="title"></h4>
                </div>
              </div>

              <slot></slot>

            </div>
          </div>
        </div>
      </div>
    </div>
    <page-modal></page-modal>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Encode from "@/directives/encode";
import PageModal from "../modal/PageModal";

export default {
  name: "FirstPage",
  components: {PageModal},
  directives: {Encode},
  mounted() {
    if (this.isAuthorized) {
      this.pushToFirstPage();
    }
    this.fetchEntitySettings();
  },
  methods: {
    ...mapActions([
        'fetchSettings',
        'pushToFirstPage',
    ]),
    fetchEntitySettings() {
      if (this.$route.params.hasOwnProperty('uuid')) {
        this.fetchSettings(this.$route.params.uuid).then(() => this.checkDisabled());
      } else {
        this.fetchSettings().then(() => this.checkDisabled());
      }
    },
    checkDisabled() {
      if (this.isDisabled) {
        try {
          this.$router.push({ name: 'Login' })
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      }
    }
  },
  computed: {
    ...mapState({
      logoUrl: state => state.settings.logoUrl,
      title: state => state.settings.title,
      isDisabled: state => state.settings.enabled !== '1',
      isAuthorized: state => state.auth.isAuthorized,
    })
  }
}
</script>

<style>
.white-background {
  background: white;
}

.logo {
  max-height: 250px;
  max-width: 100%;
  height: auto;
}

@media (max-width: 767px) {
  .logo {
    max-height: 150px;
  }
}

.no-padding {
  padding: unset !important;
}

.m-login__wrapper {
  min-height: 375px;
}

.m-login.m-login--1 .m-login__wrapper .m-login__form {
  margin-top: 2rem !important;
}

.flipInX {
  max-width: 340px;
  padding: 0 10px;
}

.max-width-320 {
  max-width: 320px;
}

@media (max-width: 768px) {
  .m-login.m-login--1 .m-login__aside {
    height: 100vh;
    padding: 1rem !important;
  }
  .main-container {
    background: #ffffff !important;
  }
}

@media (min-width: 1024px) {
  .m-login__aside {
    margin-left: 0 !important;
  }
}
</style>
